import { PublicClientApplication } from '@azure/msal-browser';
import { getDefaultConfiguration } from '@tq/auth-components';
import { b2cAuthority, b2cClientId, b2cPolicySignIn, REDIRECT_PATH } from 'tools';

const config = getDefaultConfiguration(
  b2cAuthority,
  b2cPolicySignIn,
  b2cClientId,
  REDIRECT_PATH
);

/**
 * PublicClientApplication class should be initiated only once,
 * pca should have only instance in the app
 *
 * ***DO NOT create multiple instances of pca, this will cause login loop bug***
 */
export const pca = new PublicClientApplication(config);
